import {
  afterNextRender,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  inject,
  PLATFORM_ID,
  ViewChild,
} from '@angular/core';
import { navbarMenuList } from '../../../../models/constant/navbar.constants';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UserArtistApiService } from '../../../../services/API/apiServive/user-artist-api.service';
import { FormControl, FormGroup, FormsModule } from '@angular/forms';
import { StorageService } from '../../../../services/state-management/storage.service/storage.service';
import { AuthService } from '../../../../services/API/auth.service/auth.service';
import { ExploreService } from '../../../../services/API/explore.service/exploreservice';
import { ArtList } from '../../../../models/classes/art.model';
import { ShowSearchDetailsComponent } from '../../../../shared/components/show-search-details/show-search-details.component';
import { LOCAL_STORAGE, ROLE } from '../../../../models/constant/constants';
import { LazyLoaderDirective } from '../../../../shared/directives/lazyLoad/lazy-load.directive';
import { Subject } from 'rxjs';
import { PopupService } from '../../../../services/popup/popup.service';
import { environment } from '../../../../../environments/environment';
import { isPlatformBrowser } from '@angular/common';

enum SearchTypeEnum {
  EXPLORE = 'getArtBySearchOnExplore',
  FOLLOWING = 'getArtBySearchOnFollowArtist',
  MYLIKES = 'getArtBySearchOnMyLikes',
  MYSUBSCRIPTIONS = 'getArtBySearchOnMySubscriptions',
}

@Component({
  selector: 'app-home',
  standalone: false,
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent implements AfterViewInit {
  @ViewChild(ShowSearchDetailsComponent) searchResultComponent:
    | ShowSearchDetailsComponent
    | undefined;
    @ViewChild("menu") mobileMenu?:ElementRef<HTMLMenuElement>;
  cdr = inject(ChangeDetectorRef);

  navbarMenu = navbarMenuList;
  isNotificationMenuOpen = false;
  isMenuVisible = false;
  role: ROLE = ROLE.GUEST;

  roleEnum = ROLE;
  audienceProfileId = 0;
  activeTab = this.navbarMenu[0];
  profilePic = '';
  recentSearchKeywords: string[] = [];
  @ViewChild('dropdownMenu') dropdownMenu?: ElementRef;
  @ViewChild('loadingTrigger') loadingTrigger?: ElementRef;
  @ViewChild('navbar') navbar?: ElementRef;

  notificationPagination = {
    page: 0,
    // Limit is also hardcoded from backend (that pathetic BE)
    limit: 5,
    totalPages: 0,
    totalRecords: 0,
    isLoading: false,
  };
  notificationList: any = [];
  searchForm = new FormGroup({
    search: new FormControl(''),
  });
  useSearch: SearchTypeEnum = SearchTypeEnum.EXPLORE;

  private platformID = inject(PLATFORM_ID);
  isBrowser = isPlatformBrowser(this.platformID);
  userName = '';
  isMobile = false;

  constructor(
    private authService: AuthService,
    private router: Router,
    private toaster: ToastrService,
    private storageService: StorageService,
    private userArtiestService: UserArtistApiService,
    private apiSearch: UserArtistApiService,
    private exploreService: ExploreService,
    private activatedRoute: ActivatedRoute,
    private popupService: PopupService,
    // private location:Location,
  ) {
    afterNextRender(() => {
      const data = JSON.parse(
        this.storageService.getUserData('userData') || 'null',
      );

      if (document) {
        this.isMobile = window.innerWidth <= 768;
      }

      if (data?.audienceProfileId) {
        const { role, audienceProfileId, profilePic, fullName } = data;
        this.audienceProfileId = audienceProfileId;
        this.role = role;
        this.userName = fullName;
        this.profilePic = profilePic;
      }
      this.storageService.getRole().subscribe((role) => {
        console.log(role, 'updated role');
        if (role === 'AUDIENCE') {
          this.getRecentSearchKeywords();
        }
      });
      if (this.role === ROLE.GUEST) {
        const data =
          JSON.parse(
            this.storageService.getUserData(LOCAL_STORAGE.USER_DETAILS),
          ) || {};
        const persistantSignIn = this.storageService.getPersistentSignedIn();
        this.storageService.setUserData(
          LOCAL_STORAGE.USER_DETAILS,
          JSON.stringify({ ...data, role: 'GUEST' }),
          persistantSignIn,
        );
      }
      this.getNotifications();
    });
  }

  ngOnInit(): void {
    this.storageService.onChange.subscribe((data: any) => {
      this.profilePic = data?.profilePic || this.profilePic;
    });
    this.activatedRoute.queryParams.subscribe((params) => {
      const query = params['q'];
      if (query) {
        this.searchForm.get('search')?.setValue(query);
        this.performSearch();
      }
    });
  }

  ngAfterViewInit(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.isMenuVisible = false;
        this.isMenuVisible = false;

        const urlTree = this.router.parseUrl(event.urlAfterRedirects);
        const query = urlTree.queryParams['q'];

        // Only reset if there's NO search query
        if (!query) {
          this.searchForm.reset();
          this.isSearchAble = false;
          this.SearchData = new ArtList();
          this.pageNo = 0;
          this.isLastPage = false;
          this.isLoading = false;
        }
      }
    });

    this.getRecentSearchKeywords();
  }

  getNextPage() {
    if (
      this.notificationPagination.page + 1 >=
        this.notificationPagination.totalPages ||
      this.notificationPagination.isLoading
    )
      return;

    ++this.notificationPagination.page;
    this.getNotifications();
  }

  unreadCount = 0;
  getNotifications(): void {
    this.notificationPagination.isLoading = true;
    this.exploreService
      .getNotifications(
        this.notificationPagination.limit,
        this.notificationPagination.page,
      )
      .subscribe({
        next: (res) => {
          this.notificationPagination.isLoading = false;

          if (res && res.isSuccess && res.data) {
            this.notificationPagination.totalPages = res.data.totalPages;
            this.notificationPagination.totalRecords = res.data.totalRecords;
            this.unreadCount = res.data?.content?.[0]?.unreadCount || 0;
            const list = res.data.content.map((el: any) => {
              const date = new Date(
                el.notificationTime.replace(' ', 'T') + 'Z',
              );

              return {
                ...el,
                notificationTime: date,
              };
            });
            this.notificationList.push(...list);

            list
              .filter((el: any) => !el.read)
              .map((el: any) => {
                this.unreadNotificationIds.add(el.notificationId);
              });
          }
          setTimeout(() => {
            if (this.lazyLoader) {
              this.lazyLoader.updateObserver();
            }
          }, 100);
        },
        error: (err) => {
          this.notificationPagination.isLoading = false;
        },
      });
  }

  getRecentSearchKeywords(): void | never {
    if (this.role === ROLE.GUEST) {
      return;
    }

    if (!this.audienceProfileId) {
      throw new Error(
        'Unable to fetch recent search keywords, missing Audience ID',
      );
    }
    this.exploreService.getRecentSearch(this.audienceProfileId).subscribe({
      next: (res: any) => {
        if (!res?.isSuccess) this.recentSearchKeywords = res.data;
      },
      error: (err) => {},
    });
  }

  @ViewChild(LazyLoaderDirective) lazyLoader?: LazyLoaderDirective;
  @ViewChild('scrollContainer') scrollContainer?: HTMLElement;
  toggleNotificationMenu(): void {
    if (this.isNotificationMenuOpen) {
      this.markNotificationsAsRead();
    }
    this.isNotificationMenuOpen = !this.isNotificationMenuOpen;
    setTimeout(() => {
      if (this.lazyLoader) {
        this.lazyLoader.updateObserver();
      }
      // this.initMarkAsReadObserver();
    }, 0);
  }

  closeNotificationMenu(): void {
    if (this.isNotificationMenuOpen) {
      this.isNotificationMenuOpen = false;
      this.markNotificationsAsRead();
    }
  }

  menuShow(): void {
    this.isMenuVisible = !this.isMenuVisible;
  }

  closeMenu(): void {
    this.isMenuVisible = false;
  }

  onRoleUpdate(role: ROLE): void {
    this.role = role;
    this.userArtiestService.userUpdateRole(this.role).subscribe({
      next: (response) => {
        const userData = JSON.parse(
          this.storageService.getUserData('userData'),
        );
        const staySigned = JSON.parse(
          this.storageService.getUserData('staySignedIn'),
        );
        const updatedData = JSON.stringify({ ...userData, ...response.data });
        this.storageService.setUserData('userData', updatedData, staySigned);
        if (this.role == ROLE.AUDIENCE) {
          this.router.navigateByUrl('/gallery');
        } else if (this.role == ROLE.ARTIST) {
          this.router.navigateByUrl('/gallery/uploads');
        }
      },
      error: (err) => console.error('Error updating role:', err),
    });
  }

  logout() {
    const { email } = JSON.parse(this.storageService.getUserData('userData'));
    const authToken = this.storageService.getUserData('token');

    this.authService.logOut(email, authToken).subscribe({
      next: (res) => {
        const authToken = localStorage.getItem('authToken') || '';
        localStorage.clear();
        localStorage.setItem('authToken', authToken);
        sessionStorage.clear();
        this.router.navigateByUrl('gallery/explore');
        // this.location.reload();
        setTimeout(() => {
          location.reload();
        }, 500);
        this.toaster.success(res.message || 'Logged out successfully.');
      },
      error: (err) => {
        const errMsg = err.error.message || err.message;
        this.toaster.error(errMsg);
        this.router.navigateByUrl('gallery/explore');
      },
    });
  }

  // Switch active tab
  switchTab(tab: any): void {
    this.activeTab = tab;
    this.closeSearch();
  }

  pageNo: number = -1;
  limit: number = 20;
  isLoading = false;
  isLastPage: boolean = false;
  SearchData = new ArtList();
  totalSearch: number = 0;
  noData: string = '';
  // search API
  searchKeywords = '';
  searchArt(searchTerm: string, isRefresh = true) {
    if (this.isLastPage || this.isLoading) {
      return;
    }
    if (isRefresh) {
      this.totalSearch = 0;
      this.cdr.detectChanges();
    } else {
      this.pageNo += 1;
    }
    this.isLoading = true;
    this.noData = '';
    this.searchKeywords = searchTerm;
    this.apiSearch[SearchTypeEnum.EXPLORE](
      searchTerm,
      this.limit,
      this.pageNo,
    ).subscribe({
      next: (res: any) => {
        this.totalSearch = res?.data?.totalRecords ? res.data.totalRecords : 0;
        if (!res.data) {
          this.noData = `No search results found for "${searchTerm}". Try another search`;
          this.getRecentSearchKeywords();
        }
        if (!res.data.content && !res.data.content.artDetails) return;
        this.isLastPage = this.pageNo + 1 === res.data.totalPages;
        this.isLoading = false;

        if (isRefresh) {
          this.SearchData = res.data.content;
          this.getRecentSearchKeywords();
        } else {
          this.SearchData.push(...res.data.content);
        }
        if (!this.searchResultComponent?.isOverflowing()) {
          if (!this.isLastPage) {
            setTimeout(() => {
              this.searchArt(this.searchForm.value.search || '', false);
            }, 0);
          }
        }
      },
      error: (err: any) => {
        console.error(err);
      },
      complete: () => {
        this.isLoading = false;
      },
    });
  }
  isSearchAble: boolean = false;

  goToSearch() {
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { q: this.searchForm.value.search },
      queryParamsHandling: 'merge', // optional: merges with existing params
    });
  }
  // Perform search
  performSearch(): void {
    // Reset pagination and search data for a new search term
    this.pageNo = 0;
    this.SearchData = new ArtList();
    this.isLastPage = false;
    this.isLoading = false;

    if (typeof this.searchResultComponent !== 'undefined') {
      this.searchResultComponent.reset();
    }
    const query = this.searchForm.value.search || '';

    // Trigger search
    this.getSearchData();
    if (query) {
      this.isSearchAble = true;
      this.cdr.detectChanges();
    }
  }

  searchFromKeyword(keyword: string): void {
    this.searchForm.get('search')?.setValue(keyword);
    this.goToSearch();
  }

  getSearchData(isRefresh = true) {
    const query = this.searchForm.value.search || '';
    const currentPath = this.router.url.split('/').at(-1)?.split('?q')[0];
    const currentTab = this.navbarMenu.find((el) => el.label === currentPath);
    if (currentTab) {
      this.activeTab = currentTab;
    }

    if (!query) {
      this.toaster.info('Search term cannot be empty.');
      return;
    }
    switch (this.activeTab.label.toLowerCase()) {
      case 'explore':
        this.useSearch = SearchTypeEnum.EXPLORE;
        break;
      case 'following':
        this.useSearch = SearchTypeEnum.FOLLOWING;
        break;
      case 'mylikes':
        this.useSearch = SearchTypeEnum.MYLIKES;
        break;
      case 'my-subscriptions':
        this.useSearch = SearchTypeEnum.MYSUBSCRIPTIONS;
        break;

      default:
        this.useSearch = SearchTypeEnum.EXPLORE;
    }
    this.searchArt(query, isRefresh);
  }

  closeSearch() {
    this.isSearchAble = false;
    this.SearchData = new ArtList();
    this.searchForm.reset();
  }

  redirectToExplore() {
    if (this.role === ROLE.ARTIST) {
      this.onRoleUpdate(ROLE.AUDIENCE);
    }
    if (!environment?.homeUrl) {
      this.router.navigateByUrl('/');
      return;
    }
    window.location.href = `${environment.homeUrl}`;
  }

  redirectToGallery() {
    if (this.role === ROLE.ARTIST) {
      this.onRoleUpdate(ROLE.AUDIENCE);
    }

    this.router.navigateByUrl('/gallery/explore');
  }

  @ViewChild('viewMarker')
  viewMarker?: ElementRef<HTMLDivElement>;
  private observer!: IntersectionObserver;
  private unreadNotificationIds = new Set<number>();
  // private markAsRead$ = new Subject<void>();
  private destroy$ = new Subject<void>();

  // initMarkAsReadObserver(): void {
  //   if(!this.viewMarker) return;
  //   this.observer = new IntersectionObserver((entities:Array<IntersectionObserverEntry>) => {
  //     for(let entity of entities) {
  //       if(entity.isIntersecting) {
  //         this.unreadNotificationIds.add(parseInt((entity.target as HTMLElement).dataset['id'] || "") ?? 0);
  //         this.markAsRead$.next();
  //         this.observer.unobserve(entity.target);
  //       }
  //     }
  //   })
  //   this.updateObserveTarget();
  // }

  // updateObserveTarget() {
  //   // Observe target elements
  //   if(this.viewMarker && this.observer) {
  //     Array.from(this.viewMarker.nativeElement.children).map(el => {
  //       const isUnread = !(el as HTMLElement).hasAttribute('data-read');
  //       if(isUnread) {
  //         this.observer.observe(el);
  //       }
  //     })
  //   }
  // }

  // setupDebouncedMarkAsRead() {
  //   this.markAsRead$
  //     .pipe(debounceTime(500), takeUntil(this.destroy$))
  //     .subscribe(() => this.markNotificationsAsRead());
  // }

  markNotificationsAsRead(): void {
    if (this.unreadNotificationIds.size === 0) return;

    const idsToMarkRead = Array.from(this.unreadNotificationIds);
    if (!idsToMarkRead.length) return;

    this.exploreService.markAsRead(idsToMarkRead).subscribe({
      next: (res) => {
        this.unreadCount = this.unreadCount - idsToMarkRead.length;
        this.notificationList.forEach((el: any) => {
          if (idsToMarkRead.includes(el.notificationId)) {
            el.read = true;
          }
        });
        this.unreadNotificationIds.clear();
      },
    });
  }

  removeObserver(): void {
    if (this.observer) this.observer.disconnect();
  }

  closeMobileSidebar():void {
    if(this.mobileMenu) {
      console.log(this.mobileMenu);
      (this.mobileMenu.nativeElement as any).close();
    }
  }
}
